/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Component,
  ComponentInput,
  Components,
  ComponentsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Component
 */
export const createComponent = (
    componentInput: MaybeRefOrGetter<ComponentInput>,
 signal?: AbortSignal
) => {
      componentInput = toValue(componentInput);

      return axiosClient<Component>(
      {url: `/components`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: componentInput, signal
    },
      );
    }




export const getCreateComponentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComponent>>, TError,{data: ComponentInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createComponent>>, TError,{data: ComponentInput}, TContext> => {

const mutationKey = ['createComponent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createComponent>>, {data: ComponentInput}> = (props) => {
          const {data} = props ?? {};

          return  createComponent(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateComponentMutationResult = NonNullable<Awaited<ReturnType<typeof createComponent>>>
    export type CreateComponentMutationBody = ComponentInput
    export type CreateComponentMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create Component
 */
export const useCreateComponent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComponent>>, TError,{data: ComponentInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createComponent>>,
        TError,
        {data: ComponentInput},
        TContext
      > => {
      return useMutation(getCreateComponentMutationOptions(options), queryClient);
    }
    /**
 * @summary Components list
 */
export const components = (
    params?: MaybeRefOrGetter<ComponentsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Components>(
      {url: `/components`, method: 'GET',
        params, signal
    },
      );
    }




export const getComponentsQueryKey = (params?: MaybeRefOrGetter<ComponentsParams>,) => {
    return [
    'components', ...(params ? [params] : [])
    ] as const;
    }


export const getComponentsQueryOptions = <TData = Awaited<ReturnType<typeof components>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ComponentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof components>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getComponentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof components>>> = ({ signal }) => components(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof components>>, TError, TData>
}

export type ComponentsQueryResult = NonNullable<Awaited<ReturnType<typeof components>>>
export type ComponentsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Components list
 */

export function useComponents<TData = Awaited<ReturnType<typeof components>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ComponentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof components>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getComponentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Component
 */
export const destroyComponent = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Component>(
      {url: `/components/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyComponentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyComponent>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyComponent>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyComponent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyComponent>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyComponent(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyComponentMutationResult = NonNullable<Awaited<ReturnType<typeof destroyComponent>>>

    export type DestroyComponentMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy Component
 */
export const useDestroyComponent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyComponent>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyComponent>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyComponentMutationOptions(options), queryClient);
    }
    /**
 * @summary Component Detail
 */
export const component = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Component>(
      {url: `/components/${id}`, method: 'GET', signal
    },
      );
    }




export const getComponentQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'components',id
    ] as const;
    }


export const getComponentQueryOptions = <TData = Awaited<ReturnType<typeof component>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof component>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getComponentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof component>>> = ({ signal }) => component(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof component>>, TError, TData>
}

export type ComponentQueryResult = NonNullable<Awaited<ReturnType<typeof component>>>
export type ComponentQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Component Detail
 */

export function useComponent<TData = Awaited<ReturnType<typeof component>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof component>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getComponentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Component
 */
export const updateComponent = (
    id: MaybeRefOrGetter<string>,
    componentInput: MaybeRefOrGetter<ComponentInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
componentInput = toValue(componentInput);

      return axiosClient<Component>(
      {url: `/components/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: componentInput, signal
    },
      );
    }




export const getUpdateComponentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateComponent>>, TError,{id: string;data: ComponentInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateComponent>>, TError,{id: string;data: ComponentInput}, TContext> => {

const mutationKey = ['updateComponent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateComponent>>, {id: string;data: ComponentInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateComponent(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateComponentMutationResult = NonNullable<Awaited<ReturnType<typeof updateComponent>>>
    export type UpdateComponentMutationBody = ComponentInput
    export type UpdateComponentMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Component
 */
export const useUpdateComponent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateComponent>>, TError,{id: string;data: ComponentInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateComponent>>,
        TError,
        {id: string;data: ComponentInput},
        TContext
      > => {
      return useMutation(getUpdateComponentMutationOptions(options), queryClient);
    }
